import React, { useCallback } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    CustomerButtonWrapper,
    CustomerId,
    CustomerName,
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';
import { ModelsState } from 'src/AppState/Models/ModelsState';
import { getCustomerDisplayName } from 'src/components/ComplianceAudits/utils/getCustomerDisplayName';

interface BasePropsType {
    customerId: number;
}

interface PropsWithModelsType extends BasePropsType {
    models: ModelsState;
    firstName?: never;
    surname?: never;
}

interface PropsWithNameType extends BasePropsType {
    models?: never;
    firstName: string;
    surname: string;
}

type PropsType = PropsWithModelsType | PropsWithNameType;

export const CustomerButton = observer('CustomerButton', (props: PropsType): React.ReactElement => {
    const { customerId } = props;
    const { reduxAction } = useAppStateContext();

    const handleClick = useCallback((): void => {
        reduxAction.customersActionsOpenRequest(customerId);
    }, [reduxAction, customerId]);

    const displayName = (): string => {
        if ('firstName' in props) {
            return `${props.firstName} ${props.surname}`.trim();
        }

        const customerData = props.models.getUserModel(customerId).basicData.data;

        if (customerData === null) {
            return 'Loading...';
        }

        return getCustomerDisplayName(customerData);
    };

    return (
        <CustomerButtonWrapper onClick={handleClick}>
            <CustomerName className='name'>{displayName()}</CustomerName>
            <CustomerId className='id'>{customerId}</CustomerId>
        </CustomerButtonWrapper>
    );
});
